"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryServiceFactory = exports.HistoryService = void 0;
/**
 * SSE Client using Fetch API + ReadableStream instead of EventSource
 * Allows Authorization headers to be sent with SSE requests
 */
var SSEClient = /** @class */ (function () {
    function SSEClient(url, getToken, onmessage, onerror, reconnectDelay, shouldReconnect) {
        if (reconnectDelay === void 0) { reconnectDelay = 5000; }
        this.url = url;
        this.getToken = getToken;
        this.onmessage = onmessage;
        this.onerror = onerror;
        this.reconnectDelay = reconnectDelay;
        this.abortController = null;
        this.reconnectTimer = null;
        this.isConnecting = false;
        this.isActive = false;
        this.shouldReconnect = shouldReconnect || (function () { return true; });
    }
    SSEClient.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, headers, response, err, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isConnecting || this.isActive)
                            return [2 /*return*/];
                        this.isConnecting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (this.abortController) {
                            this.abortController.abort();
                        }
                        this.abortController = new AbortController();
                        token = this.getToken();
                        if (!token) {
                            console.warn('SSE: No auth token available, stream will likely fail');
                        }
                        headers = {
                            'Content-Type': 'text/event-stream'
                        };
                        if (token) {
                            headers['Authorization'] = token.startsWith('Bearer ') ? token : "Bearer ".concat(token);
                        }
                        return [4 /*yield*/, fetch(this.url, {
                                method: 'GET',
                                headers: headers,
                                signal: this.abortController.signal
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            err = new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
                            err.status = response.status;
                            throw err;
                        }
                        this.isConnecting = false;
                        this.isActive = true;
                        if (!response.body) {
                            throw new Error('No response body');
                        }
                        return [4 /*yield*/, this.processStream(response.body)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.isConnecting = false;
                        this.isActive = false;
                        if (error_1.name !== 'AbortError') {
                            if (typeof navigator !== 'undefined' && navigator.onLine) {
                                console.error('SSE connection error:', error_1);
                            }
                            this.onerror(error_1);
                            this.scheduleReconnect();
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SSEClient.prototype.processStream = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var reader, decoder, buffer, _a, done, value, lines, i, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        reader = body.getReader();
                        decoder = new TextDecoder();
                        buffer = '';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        _b.label = 2;
                    case 2:
                        if (!true) return [3 /*break*/, 4];
                        return [4 /*yield*/, reader.read()];
                    case 3:
                        _a = _b.sent(), done = _a.done, value = _a.value;
                        if (done)
                            return [3 /*break*/, 4];
                        buffer += decoder.decode(value, { stream: true });
                        lines = buffer.split('\n');
                        // Process all complete lines, keep incomplete last line in buffer
                        buffer = lines[lines.length - 1];
                        for (i = 0; i < lines.length - 1; i++) {
                            this.processLine(lines[i]);
                        }
                        return [3 /*break*/, 2];
                    case 4:
                        // Process any remaining data
                        if (buffer) {
                            this.processLine(buffer);
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        error_2 = _b.sent();
                        if (error_2.name !== 'AbortError') {
                            console.error('SSE stream processing error:', error_2);
                            this.onerror(error_2);
                            this.scheduleReconnect();
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        reader.releaseLock();
                        this.isActive = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SSEClient.prototype.processLine = function (line) {
        // SSE line format: "data: {...}"
        if (!line.trim())
            return; // Skip empty lines
        if (line.startsWith('data:')) {
            var dataStr = line.substring(5).trim();
            try {
                var data = JSON.parse(dataStr);
                this.onmessage(data);
            }
            catch (e) {
                console.error('Failed to parse SSE data:', e);
            }
        }
    };
    SSEClient.prototype.scheduleReconnect = function () {
        var _this = this;
        if (!this.shouldReconnect())
            return;
        if (this.reconnectTimer)
            return;
        this.reconnectTimer = setTimeout(function () {
            _this.reconnectTimer = null;
            _this.connect();
        }, this.reconnectDelay);
    };
    SSEClient.prototype.close = function () {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
        this.isActive = false;
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }
    };
    return SSEClient;
}());
var HistoryService = /** @class */ (function () {
    function HistoryService($window, $http, $q, $rootScope) {
        this.$window = $window;
        this.$http = $http;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.STORAGE_KEYS = {
            searches: 'audroam.history.searches',
            views: 'audroam.history.views',
            scans: 'audroam.history.scans',
            focus: 'audroam.history.focus'
        };
        this.MAX_ENTRIES = 50;
        this.MAX_FOCUS_ENTRIES = 20;
        this.SYNC_INTERVAL = 300000; // 5 minutes
        this.MIN_FETCH_INTERVAL_MS = 60000; // Avoid repeated full syncs
        this.STREAM_BACKGROUND_IDLE_MS = 120000; // Close stream after 2 minutes in background
        this.API_BASE = '/api/v2/history';
        this.sseClient = null;
        this.lastSyncedAt = null;
        this.changeCallbacks = [];
        this.reconnectHandlersBound = false;
        this.resumeHandler = null;
        this.lastReconnectToastAt = null;
        this.lastFetchAt = null;
        this.streamIdleTimer = null;
        this.lastFocusEntry = null;
        this.FOCUS_DEBOUNCE_MS = 500;
        this.authRefreshPending = false;
        this.startSync();
        this.bindReconnectHandlers();
        this.bindAuthRefreshHandler();
    }
    /**
     * Add a search entry to history
     */
    HistoryService.prototype.addSearchEntry = function (text, params, realm, account) {
        // Skip if text is empty
        if (!text)
            return;
        var entry = {
            id: this.generateId(),
            timestamp: Date.now(),
            data: { text: text, params: params, realm: realm, account: account },
            caption: this.generateSearchCaption(text, realm, account)
        };
        // Deduplicate by caption - removes old entry with same caption before adding new
        this.addEntry('searches', entry, function (e) {
            return e.caption === entry.caption || (!e.caption && e.data.text === text);
        });
    };
    /**
     * Add a view entry to history.
     * Third arg may be a legacy title string or a ViewHistoryMeta object.
     */
    HistoryService.prototype.addViewEntry = function (pnid, url, titleOrMeta) {
        var meta = titleOrMeta && typeof titleOrMeta === 'object'
            ? titleOrMeta
            : titleOrMeta
                ? { title: String(titleOrMeta) }
                : {};
        var resolvedUrl = url || (pnid ? "/view/pnid/".concat(pnid) : undefined);
        var entry = {
            id: this.generateId(),
            timestamp: Date.now(),
            data: {
                pnid: pnid,
                url: resolvedUrl,
                title: meta.title,
                taskGroup: meta.taskGroup,
                topicGroup: meta.topicGroup,
                topicDetail: meta.topicDetail,
                bodyPreview: meta.bodyPreview,
                account: meta.account,
                realm: meta.realm,
                threadId: meta.threadId,
                threadKind: meta.threadKind,
            },
            caption: this.generateViewCaption(pnid, resolvedUrl, meta),
        };
        // Deduplicate by pnid/url/threadId (not caption — caption improves over time via enrich)
        this.addEntry('views', entry, function (e) {
            return !!(meta.threadId && e.data.threadId === meta.threadId) ||
                !!(pnid && e.data.pnid === pnid) ||
                !!(resolvedUrl && e.data.url === resolvedUrl) ||
                (!!entry.caption && e.caption === entry.caption);
        });
    };
    /**
     * Save (or refresh) a view-history entry once row fields are known.
     * Call after personSearch bindResult — do not backfill old URL-only entries.
     * Payload (task/topic/body preview) is what syncs to Python ui_history.
     */
    HistoryService.prototype.enrichViewEntry = function (pnid, row) {
        if (!pnid || !row)
            return;
        var meta = this.metaFromRow(row);
        // Skip if we have nothing human-readable yet (keep prior bare URL entries alone).
        if (!meta.taskGroup && !meta.topicGroup && !meta.topicDetail && !meta.bodyPreview) {
            return;
        }
        this.addViewEntry(pnid, "/view/pnid/".concat(pnid), meta);
    };
    HistoryService.prototype.metaFromRow = function (row) {
        if (!row)
            return {};
        // Search rows use pn*; timeline spans may use camelCase / snake_case.
        var bodyRaw = row.pnBody != null
            ? String(row.pnBody)
            : row.body != null
                ? String(row.body)
                : row.title != null
                    ? String(row.title)
                    : '';
        var bodyPreview = this.bodyPreviewFromText(bodyRaw);
        return {
            title: row.pnTopicDetail || row.topicDetail || undefined,
            taskGroup: row.pnTaskGroup || row.taskGroup || row.task_group || undefined,
            topicGroup: row.pnTopicGroup || row.topicGroup || row.topic || row.topic_group || undefined,
            topicDetail: row.pnTopicDetail || row.topicDetail || row.topic_detail || undefined,
            bodyPreview: bodyPreview || undefined,
            account: row.pnAccount || row.account || undefined,
            realm: row.pnUserRealm || row.pnAssetRealm || row.realm || undefined,
        };
    };
    HistoryService.prototype.bodyPreviewFromText = function (body, maxLen) {
        if (maxLen === void 0) { maxLen = 72; }
        if (!body)
            return '';
        var line = body
            .replace(/\r\n?/g, '\n')
            .split('\n')
            .map(function (l) { return l.trim(); })
            .find(function (l) { return l.length > 0; });
        if (!line)
            return '';
        var cleaned = line
            .replace(/^#{1,6}\s+/, '')
            .replace(/^[-*+]\s+/, '')
            .replace(/^\d+\.\s+/, '')
            .replace(/\s+/g, ' ')
            .trim();
        return cleaned.length > maxLen ? "".concat(cleaned.slice(0, maxLen), "\u2026") : cleaned;
    };
    /**
     * Human label for History dropdown (and server rehydrate).
     * Prefer task/topic + first line of pnBody; fall back to Note #id or url.
     */
    HistoryService.prototype.generateViewCaption = function (pnid, url, meta) {
        var m = meta || {};
        var cats = [m.taskGroup, m.topicGroup, m.topicDetail]
            .map(function (x) { return (x != null ? String(x).trim() : ''); })
            .filter(function (x) { return x.length > 0; });
        var uniqueCats = [];
        for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
            var c = cats_1[_i];
            if (!uniqueCats.length || uniqueCats[uniqueCats.length - 1] !== c) {
                uniqueCats.push(c);
            }
        }
        var catStr = uniqueCats.join(' · ');
        var body = (m.bodyPreview || m.title || '').trim();
        var bodyDistinct = body && body !== catStr && !uniqueCats.includes(body);
        if (catStr && bodyDistinct) {
            return "".concat(catStr, " \u2014 ").concat(body);
        }
        if (body)
            return body;
        if (catStr)
            return catStr;
        if (pnid)
            return "Note #".concat(pnid);
        return url || 'View';
    };
    /**
     * Add a scan entry to history
     */
    HistoryService.prototype.addScanEntry = function (tag, realm, account) {
        // Skip if tag is empty
        if (!tag)
            return;
        var entry = {
            id: this.generateId(),
            timestamp: Date.now(),
            data: { tag: tag, realm: realm, account: account },
            caption: this.generateScanCaption(tag, realm, account)
        };
        // Deduplicate by caption - removes old entry with same caption before adding new
        this.addEntry('scans', entry, function (e) {
            return e.caption === entry.caption || (!e.caption && e.data.tag === tag);
        });
    };
    /**
     * Add a focus entry to history (debounced to 500ms).
     * Pass recentDigest after a fresh Recent load so peers can merge by note ID via SSE.
     * Pass threadMemberDigest after membership status/role changes for live checklist fan-out.
     * force: true bypasses debounce (needed when attaching a digest right after a realm switch).
     *
     * When publishing only threadMemberDigest, re-attach the last local recentDigest for the
     * same realm/account so server upsert (keyed by realm+account) does not drop Recent rows.
     */
    HistoryService.prototype.addFocusEntry = function (realm, account, opts) {
        var _a;
        if (!realm || !account)
            return;
        var now = Date.now();
        var hasRecentDigest = (opts === null || opts === void 0 ? void 0 : opts.recentDigest) != null &&
            Array.isArray(opts.recentDigest.rows) &&
            opts.recentDigest.rows.length > 0;
        var hasThreadDigest = (opts === null || opts === void 0 ? void 0 : opts.threadMemberDigest) != null &&
            Array.isArray(opts.threadMemberDigest.patches) &&
            opts.threadMemberDigest.patches.length > 0;
        var hasDigest = hasRecentDigest || hasThreadDigest;
        // Skip if same focus within debounce window (unless force or publishing a digest)
        if (!(opts === null || opts === void 0 ? void 0 : opts.force) &&
            !hasDigest &&
            this.lastFocusEntry &&
            this.lastFocusEntry.realm === realm &&
            this.lastFocusEntry.account === account &&
            now - this.lastFocusEntry.timestamp < this.FOCUS_DEBOUNCE_MS) {
            return;
        }
        // Update last focus entry tracker
        this.lastFocusEntry = { realm: realm, account: account, timestamp: now };
        var data = { realm: realm, account: account };
        if (hasRecentDigest && (opts === null || opts === void 0 ? void 0 : opts.recentDigest)) {
            data.recentDigest = opts.recentDigest;
        }
        else if (hasThreadDigest) {
            // Preserve prior Recent snapshot so focus upsert does not wipe peer Recent
            var prior = this.getFocusHistory().find(function (e) { var _a, _b, _c; return ((_a = e.data) === null || _a === void 0 ? void 0 : _a.realm) === realm && ((_b = e.data) === null || _b === void 0 ? void 0 : _b.account) === account && ((_c = e.data) === null || _c === void 0 ? void 0 : _c.recentDigest); });
            if ((_a = prior === null || prior === void 0 ? void 0 : prior.data) === null || _a === void 0 ? void 0 : _a.recentDigest) {
                data.recentDigest = prior.data.recentDigest;
            }
        }
        if (hasThreadDigest && (opts === null || opts === void 0 ? void 0 : opts.threadMemberDigest)) {
            data.threadMemberDigest = opts.threadMemberDigest;
        }
        var entry = {
            id: this.generateId(),
            timestamp: now,
            data: data,
            caption: this.generateFocusCaption(realm, account),
        };
        // Deduplicate by caption - removes old entry with same realm+account before adding new
        this.addEntry('focus', entry, function (e) {
            return e.caption === entry.caption ||
                (!e.caption && e.data.realm === realm && e.data.account === account);
        });
    };
    /**
     * Hide a focus entry (mark as hidden, don't show in recent list)
     */
    HistoryService.prototype.hideFocusEntry = function (realm, account) {
        var entries = this.getEntries('focus');
        var changed = false;
        entries.forEach(function (entry) {
            if (entry.data.realm === realm && entry.data.account === account && !entry.hidden) {
                entry.hidden = true;
                changed = true;
            }
        });
        if (changed) {
            this.saveEntries('focus', entries);
            this.notifyChange();
        }
    };
    /**
     * Generate caption for search entry
     */
    HistoryService.prototype.generateSearchCaption = function (text, realm, account) {
        if (realm && account) {
            return "".concat(text, " @ ").concat(realm, "/").concat(account);
        }
        else if (realm) {
            return "".concat(text, " @ ").concat(realm);
        }
        return text;
    };
    /**
     * Generate caption for scan entry
     */
    HistoryService.prototype.generateScanCaption = function (tag, realm, account) {
        if (realm && account) {
            return "".concat(tag, " @ ").concat(realm, "/").concat(account);
        }
        else if (realm) {
            return "".concat(tag, " @ ").concat(realm);
        }
        return tag;
    };
    /**
     * Generate caption for focus entry
     */
    HistoryService.prototype.generateFocusCaption = function (realm, account) {
        return "".concat(realm, "/").concat(account);
    };
    /**
     * Smart history recording - analyzes search args and records appropriate history type(s)
     */
    HistoryService.prototype.recordSearchFromArgs = function (args) {
        if (!args)
            return;
        // Record scan history for tag searches
        if (args.tag && typeof args.tag === 'string' && args.tag.trim()) {
            console.log('Recording scan history from args:', args.tag.trim());
            this.addScanEntry(args.tag.trim());
        }
        // Record search history for text searches
        if (args.s && typeof args.s === 'string' && args.s.trim()) {
            console.log('Recording search history from args:', args.s.trim());
            this.addSearchEntry(args.s.trim(), args);
        }
        // View history is saved only once the row is loaded (enrichViewEntry in
        // bindResult) so the stored caption includes task/topic/pnBody — not a bare URL.
        // Old URL-only local/server entries are left as-is.
        // Additional search types that should be recorded as searches
        if (args.code && typeof args.code === 'string' && args.code.trim()) {
            console.log('Recording search history for code:', args.code.trim());
            this.addSearchEntry('code:' + args.code.trim(), args);
        }
        if (args.realm && typeof args.realm === 'string' && args.realm.trim() && !args.tag && !args.s) {
            console.log('Recording search history for realm:', args.realm.trim());
            this.addSearchEntry('realm:' + args.realm.trim(), args);
        }
        if (args.hint && typeof args.hint === 'string' && args.hint.trim()) {
            console.log('Recording search history for hint:', args.hint.trim());
            this.addSearchEntry('hint:' + args.hint.trim(), args);
        }
        if (args.point && typeof args.point === 'string' && args.point.trim()) {
            console.log('Recording search history for point:', args.point.trim());
            this.addSearchEntry('point:' + args.point.trim(), args);
        }
    };
    /**
     * Get search history sorted by most recent first
     */
    HistoryService.prototype.getSearchHistory = function () {
        var entries = this.getEntries('searches');
        return entries.sort(function (a, b) { return b.timestamp - a.timestamp; });
    };
    /**
     * Get view history sorted by most recent first
     */
    HistoryService.prototype.getViewHistory = function () {
        var entries = this.getEntries('views');
        return entries.sort(function (a, b) { return b.timestamp - a.timestamp; });
    };
    /**
     * Get scan history sorted by most recent first
     */
    HistoryService.prototype.getScanHistory = function () {
        var entries = this.getEntries('scans');
        return entries.sort(function (a, b) { return b.timestamp - a.timestamp; });
    };
    /**
     * Get focus history sorted by most recent first (excluding hidden entries)
     */
    HistoryService.prototype.getFocusHistory = function () {
        var entries = this.getEntries('focus');
        return entries
            .filter(function (e) { return !e.hidden; })
            .sort(function (a, b) { return b.timestamp - a.timestamp; })
            .slice(0, this.MAX_FOCUS_ENTRIES);
    };
    /**
     * Get all history types at once
     */
    HistoryService.prototype.getAllHistory = function () {
        return {
            searches: this.getSearchHistory(),
            views: this.getViewHistory(),
            scans: this.getScanHistory(),
            focus: this.getFocusHistory()
        };
    };
    /**
     * Register callback to be notified when history changes
     */
    HistoryService.prototype.onChange = function (callback) {
        var _this = this;
        this.changeCallbacks.push(callback);
        // Return unsubscribe function
        return function () {
            var index = _this.changeCallbacks.indexOf(callback);
            if (index > -1) {
                _this.changeCallbacks.splice(index, 1);
            }
        };
    };
    /**
     * Notify all subscribers that history has changed
     */
    HistoryService.prototype.notifyChange = function () {
        this.changeCallbacks.forEach(function (callback) {
            try {
                callback();
            }
            catch (e) {
                console.error('History change callback error:', e);
            }
        });
    };
    /**
     * Clear all history for a type
     */
    HistoryService.prototype.clearHistory = function (type) {
        var key = this.STORAGE_KEYS[type];
        this.$window.localStorage.removeItem(key);
        this.notifyChange();
    };
    /**
     * Clear specific entry
     */
    HistoryService.prototype.removeEntry = function (type, id) {
        var entries = this.getEntries(type);
        var filtered = entries.filter(function (entry) { return entry.id !== id; });
        this.saveEntries(type, filtered);
        this.notifyChange();
    };
    /**
     * Clear all history
     */
    HistoryService.prototype.clearAllHistory = function () {
        var _this = this;
        Object.values(this.STORAGE_KEYS).forEach(function (key) {
            _this.$window.localStorage.removeItem(key);
        });
        this.notifyChange();
    };
    /**
     * Clear all client history and force fresh sync from server
     * Useful for mobile to reset state and pull all data fresh
     */
    HistoryService.prototype.clearAllAndSync = function () {
        console.log('[HistoryService] Clearing all history and forcing fresh sync...');
        // Clear all localStorage entries
        this.clearAllHistory();
        // Reset sync timestamp so next fetch gets everything from server
        this.lastSyncedAt = null;
        this.$window.localStorage.removeItem('audroam.history.last_synced');
        // Immediately fetch fresh data from server
        return this.fetchFromServer();
    };
    /**
     * Start background sync with server
     */
    HistoryService.prototype.startSync = function () {
        this.loadLastSyncedAt();
        if (this.isOnline()) {
            this.fetchFromServer();
            this.startEventStream();
        }
        this.scheduleSync();
    };
    HistoryService.prototype.isOnline = function () {
        return typeof this.$window.navigator === 'undefined' || this.$window.navigator.onLine !== false;
    };
    /**
     * Stop background sync
     */
    HistoryService.prototype.stopSync = function () {
        if (this.syncTimer) {
            clearInterval(this.syncTimer);
            this.syncTimer = null;
        }
        if (this.sseClient) {
            this.sseClient.close();
            this.sseClient = null;
        }
    };
    HistoryService.prototype.bindReconnectHandlers = function () {
        var _this = this;
        if (this.reconnectHandlersBound)
            return;
        this.reconnectHandlersBound = true;
        this.resumeHandler = function () {
            if (!_this.isOnline()) {
                _this.stopEventStream();
                return;
            }
            var doc = _this.$window.document;
            if (doc && doc.hidden) {
                _this.scheduleBackgroundStreamClose();
                return;
            }
            _this.clearBackgroundStreamClose();
            if (_this.sseClient) {
                return;
            }
            _this.reconnectEventStream('resume');
        };
        this.$window.addEventListener('online', this.resumeHandler);
        this.$window.addEventListener('offline', function () {
            _this.stopEventStream();
        });
        this.$window.addEventListener('focus', this.resumeHandler);
        if (this.$window.document && this.$window.document.addEventListener) {
            this.$window.document.addEventListener('visibilitychange', this.resumeHandler);
        }
    };
    HistoryService.prototype.reconnectEventStream = function (reason) {
        if (this.sseClient) {
            this.sseClient.close();
            this.sseClient = null;
        }
        this.startEventStream();
        if (this.shouldFetchFromServer()) {
            this.fetchFromServer();
        }
        this.notifyReconnect(reason);
    };
    HistoryService.prototype.notifyReconnect = function (reason) {
        var now = Date.now();
        if (this.lastReconnectToastAt && now - this.lastReconnectToastAt < 10000) {
            return;
        }
        this.lastReconnectToastAt = now;
        try {
            this.$rootScope.$broadcast('history:sseReconnected', { reason: reason });
        }
        catch (e) {
            console.warn('Failed to broadcast history SSE reconnect event:', e);
        }
    };
    /**
     * Sync specific entries to server (immediate or batch)
     */
    HistoryService.prototype.syncToServer = function (entries) {
        var _this = this;
        var entriesToSync = entries || this.getUnsyncedEntries();
        if (entriesToSync.length === 0) {
            return this.$q.resolve({ processed: 0, duplicates: 0, errors: 0 });
        }
        // Check for auth token - required for sync
        var token = this.$window.localStorage.getItem('jwt_token');
        if (!token) {
            console.warn('[HistoryService] No auth token available - sync blocked');
            // Don't reject; will retry on next interval when token is available
            return this.$q.resolve({ processed: 0, duplicates: 0, errors: 0, queued: entriesToSync.length });
        }
        var payload = {
            entries: entriesToSync.map(function (entry) { return ({
                client_entry_id: entry.id,
                entry_type: _this.getEntryType(entry),
                entry_timestamp: new Date(entry.timestamp).toISOString(),
                payload: entry.data,
                device_id: _this.getDeviceId(),
                user_agent: navigator.userAgent
            }); })
        };
        console.debug("[HistoryService] Syncing ".concat(entriesToSync.length, " entries to ").concat(this.API_BASE, "/sync"));
        return this.$http.post("".concat(this.API_BASE, "/sync"), payload)
            .then(function (response) {
            var result = response.data;
            console.log("[HistoryService] Sync response: processed=".concat(result.processed, ", duplicates=").concat(result.duplicates, ", errors=").concat(result.errors));
            if (result.success) {
                _this.markSynced(entriesToSync);
                _this.updateLastSyncedAt();
            }
            return result;
        })
            .catch(function (error) {
            var status = (error === null || error === void 0 ? void 0 : error.status) || '?';
            var statusText = (error === null || error === void 0 ? void 0 : error.statusText) || 'Unknown';
            var errorData = (error === null || error === void 0 ? void 0 : error.data) || {};
            console.error("[HistoryService] Sync failed (HTTP ".concat(status, " ").concat(statusText, "):"), errorData, error);
            // Log details for debugging
            if (status === 401 || status === 403) {
                console.error('[HistoryService] Authentication error - check jwt_token in localStorage');
            }
            else if (status === 404) {
                console.error('[HistoryService] API endpoint not found - check server configuration');
            }
            else if (status >= 500) {
                console.error('[HistoryService] Server error - check server logs');
            }
            else if (status === 0 || status === 'Network') {
                console.error('[HistoryService] Network error - check connectivity');
            }
            // Return error result instead of rejecting to prevent promise from hanging
            // Entries remain unsynced and will retry on next interval
            return _this.$q.resolve({
                processed: 0,
                duplicates: 0,
                errors: entriesToSync.length,
                syncError: true,
                errorMessage: "".concat(status, " ").concat(statusText)
            });
        });
    };
    /**
     * Immediately sync a single entry to server for real-time updates
     */
    HistoryService.prototype.syncEntryImmediate = function (entry) {
        this.syncToServer([entry]).then(function (result) {
            if (result.syncError) {
                console.warn("[HistoryService] Immediate sync failed for entry ".concat(entry.id, ", will retry in batch:"), result.errorMessage);
            }
        }).catch(function (error) {
            console.warn("[HistoryService] Immediate sync error for entry ".concat(entry.id, ":"), error);
        });
    };
    /**
     * Fetch recent entries from server
     */
    HistoryService.prototype.fetchFromServer = function () {
        var _this = this;
        if (!this.isOnline()) {
            return this.$q.resolve({ entries: [] });
        }
        var params = { limit: 50 };
        if (this.lastSyncedAt) {
            params.since = this.lastSyncedAt;
        }
        return this.$http.get("".concat(this.API_BASE, "/recent"), { params: params })
            .then(function (response) {
            var data = response.data;
            if (data && data.entries) {
                console.log("[HistoryService] Synced ".concat(data.entries.length, " entries from server"));
                _this.mergeServerEntries(data.entries);
            }
            _this.lastFetchAt = Date.now();
            return data;
        })
            .catch(function (error) {
            if (!_this.isOnline() || (error === null || error === void 0 ? void 0 : error.status) === 0 || (error === null || error === void 0 ? void 0 : error.status) === -1) {
                return _this.$q.resolve({ entries: [] });
            }
            console.error('[HistoryService] Fetch history failed:', error);
            return _this.$q.resolve({ entries: [], fetchError: true });
        });
    };
    HistoryService.prototype.shouldFetchFromServer = function () {
        if (!this.lastFetchAt) {
            return true;
        }
        return (Date.now() - this.lastFetchAt) >= this.MIN_FETCH_INTERVAL_MS;
    };
    HistoryService.prototype.startEventStream = function () {
        var _this = this;
        if (!this.isOnline()) {
            this.stopEventStream();
            return;
        }
        if (this.sseClient) {
            this.sseClient.close();
        }
        var getToken = function () { return _this.$window.localStorage.getItem('jwt_token'); };
        var onmessage = function (data) {
            try {
                if (data.type === 'new_entry') {
                    _this.handleServerEntry(data.entry);
                }
                else if (data.type === 'heartbeat') {
                    // Heartbeat - just acknowledge connection is alive
                }
            }
            catch (e) {
                console.error('Failed to handle SSE message:', e);
            }
        };
        var onerror = function (error) {
            var _a;
            if (_this.isOnline()) {
                console.error('SSE stream error:', error);
            }
            var status = error === null || error === void 0 ? void 0 : error.status;
            if (status === 401 || status === 403) {
                _this.authRefreshPending = true;
                try {
                    (_a = _this.sseClient) === null || _a === void 0 ? void 0 : _a.close();
                }
                catch (_b) { }
                _this.sseClient = null;
            }
            // Reconnect will be handled by SSEClient's scheduleReconnect
        };
        this.sseClient = new SSEClient("".concat(this.API_BASE, "/stream"), getToken, onmessage, onerror, 5000, // 5 second reconnect delay
        function () { var _a; return _this.isOnline() && !((_a = _this.$window.document) === null || _a === void 0 ? void 0 : _a.hidden) && !_this.authRefreshPending; });
        this.sseClient.connect().catch(function (error) {
            if (_this.isOnline()) {
                console.error('Failed to connect SSE stream:', error);
            }
        });
        this.clearBackgroundStreamClose();
    };
    HistoryService.prototype.scheduleBackgroundStreamClose = function () {
        var _this = this;
        if (this.streamIdleTimer) {
            return;
        }
        this.streamIdleTimer = this.$window.setTimeout(function () {
            _this.streamIdleTimer = null;
            if (_this.$window.document && _this.$window.document.hidden) {
                _this.stopEventStream();
            }
        }, this.STREAM_BACKGROUND_IDLE_MS);
    };
    HistoryService.prototype.clearBackgroundStreamClose = function () {
        if (this.streamIdleTimer) {
            this.$window.clearTimeout(this.streamIdleTimer);
            this.streamIdleTimer = null;
        }
    };
    HistoryService.prototype.stopEventStream = function () {
        if (this.sseClient) {
            this.sseClient.close();
            this.sseClient = null;
        }
    };
    HistoryService.prototype.bindAuthRefreshHandler = function () {
        var _this = this;
        this.$rootScope.$on('auth:tokenRefreshed', function () {
            _this.authRefreshPending = false;
            var doc = _this.$window.document;
            if (doc && doc.hidden) {
                return;
            }
            if (!_this.sseClient) {
                _this.reconnectEventStream('token-refresh');
            }
        });
    };
    HistoryService.prototype.scheduleSync = function () {
        var _this = this;
        this.syncTimer = setInterval(function () {
            if (!_this.isOnline()) {
                return;
            }
            _this.syncToServer();
        }, this.SYNC_INTERVAL);
    };
    HistoryService.prototype.getUnsyncedEntries = function () {
        var _this = this;
        var allEntries = [];
        ['searches', 'views', 'scans', 'focus'].forEach(function (type) {
            var entries = _this.getEntries(type);
            allEntries.push.apply(allEntries, entries);
        });
        return allEntries.filter(function (entry) { return !entry.synced; });
    };
    HistoryService.prototype.markSynced = function (entries) {
        var _this = this;
        // Mark entries as synced in localStorage
        var entriesById = new Map(entries.map(function (e) { return [e.id, e]; }));
        ['searches', 'views', 'scans', 'focus'].forEach(function (type) {
            var storageEntries = _this.getEntries(type);
            var changed = false;
            storageEntries.forEach(function (entry) {
                if (entriesById.has(entry.id) && !entry.synced) {
                    entry.synced = true;
                    changed = true;
                }
            });
            if (changed) {
                _this.saveEntries(type, storageEntries);
            }
        });
        this.updateLastSyncedAt();
    };
    HistoryService.prototype.getEntryType = function (entry) {
        if ('text' in entry.data)
            return 'search';
        if ('pnid' in entry.data || 'url' in entry.data)
            return 'view';
        if ('tag' in entry.data && !('text' in entry.data))
            return 'scan';
        if ('realm' in entry.data && 'account' in entry.data && !('text' in entry.data) && !('tag' in entry.data))
            return 'focus';
        return 'unknown';
    };
    HistoryService.prototype.getDeviceId = function () {
        var deviceId = this.$window.localStorage.getItem('audroam.device_id');
        if (!deviceId) {
            deviceId = Date.now().toString(36) + Math.random().toString(36).substr(2);
            this.$window.localStorage.setItem('audroam.device_id', deviceId);
        }
        return deviceId;
    };
    HistoryService.prototype.loadLastSyncedAt = function () {
        this.lastSyncedAt = this.$window.localStorage.getItem('audroam.history.last_synced');
    };
    HistoryService.prototype.updateLastSyncedAt = function () {
        this.lastSyncedAt = new Date().toISOString();
        this.$window.localStorage.setItem('audroam.history.last_synced', this.lastSyncedAt);
    };
    /**
     * @param opts.live when true (SSE), a remote focus entry triggers Focus card refresh
     * via history:remoteFocus. Bulk GET /history/recent merges must not fire that.
     */
    HistoryService.prototype.mergeServerEntries = function (serverEntries, opts) {
        var _this = this;
        // Merge server entries into local storage
        serverEntries.forEach(function (serverEntry) {
            var payload = serverEntry.payload;
            var type = serverEntry.entry_type;
            // Generate caption from server payload based on entry type
            var caption;
            if (type === 'search' && payload.text) {
                caption = _this.generateSearchCaption(payload.text, payload.realm, payload.account);
            }
            else if (type === 'scan' && payload.tag) {
                caption = _this.generateScanCaption(payload.tag, payload.realm, payload.account);
            }
            else if (type === 'view') {
                caption = _this.generateViewCaption(payload.pnid, payload.url, {
                    title: payload.title,
                    taskGroup: payload.taskGroup,
                    topicGroup: payload.topicGroup,
                    topicDetail: payload.topicDetail,
                    bodyPreview: payload.bodyPreview,
                    account: payload.account,
                    realm: payload.realm,
                });
            }
            else if (type === 'focus' && payload.realm && payload.account) {
                caption = _this.generateFocusCaption(payload.realm, payload.account);
            }
            var localEntry = {
                id: serverEntry.client_entry_id,
                timestamp: new Date(serverEntry.entry_timestamp).getTime(),
                data: payload,
                synced: true,
                caption: caption
            };
            // Deduplicate by caption (content-based) instead of client_entry_id
            var isDuplicate = function (e) {
                return (caption && e.caption === caption) || e.id === serverEntry.client_entry_id;
            };
            if (type === 'search') {
                _this.addEntry('searches', localEntry, isDuplicate);
            }
            else if (type === 'view') {
                _this.addEntry('views', localEntry, isDuplicate);
            }
            else if (type === 'scan') {
                _this.addEntry('scans', localEntry, isDuplicate);
            }
            else if (type === 'focus') {
                _this.addEntry('focus', localEntry, isDuplicate);
                // Live SSE only: other device/tab realm sign-on → Focus via Python, not PHP recent
                if (opts && opts.live) {
                    try {
                        _this.$rootScope.$broadcast('history:remoteFocus', localEntry);
                    }
                    catch (_a) {
                        /* ignore */
                    }
                }
            }
            else {
                console.warn("[HistoryService] Unknown entry type: ".concat(type));
            }
        });
    };
    HistoryService.prototype.handleServerEntry = function (serverEntry) {
        // Live SSE path — may signal Focus card refresh for focus entries
        this.mergeServerEntries([serverEntry], { live: true });
    };
    HistoryService.prototype.addEntry = function (type, entry, isDuplicate) {
        var entries = this.getEntries(type);
        // Check if this is a duplicate of an existing entry
        if (isDuplicate && entries.some(isDuplicate)) {
            // Entry already exists, just update its timestamp by removing and re-adding at top
            entries = entries.filter(function (e) { return !isDuplicate(e); });
        }
        // Ensure new entries are marked as unsynced
        if (entry.synced === undefined) {
            entry.synced = false;
        }
        entries.unshift(entry); // Add to beginning (most recent first)
        // Limit to MAX_ENTRIES or MAX_FOCUS_ENTRIES based on type
        var maxEntries = type === 'focus' ? this.MAX_FOCUS_ENTRIES : this.MAX_ENTRIES;
        if (entries.length > maxEntries) {
            entries.splice(maxEntries);
        }
        this.saveEntries(type, entries);
        this.notifyChange();
        // Immediately sync to server for real-time updates across tabs
        // If this fails, entry remains unsynced and will be picked up by batch sync
        if (!entry.synced) {
            this.syncEntryImmediate(entry);
        }
    };
    HistoryService.prototype.getEntries = function (type) {
        try {
            var key = this.STORAGE_KEYS[type];
            var stored = this.$window.localStorage.getItem(key);
            if (stored) {
                var parsed = JSON.parse(stored);
                if (Array.isArray(parsed)) {
                    return parsed;
                }
            }
        }
        catch (error) {
            console.error('Failed to load history from localStorage:', error);
        }
        return [];
    };
    HistoryService.prototype.saveEntries = function (type, entries) {
        try {
            var key = this.STORAGE_KEYS[type];
            this.$window.localStorage.setItem(key, JSON.stringify(entries));
        }
        catch (error) {
            console.error('Failed to save history to localStorage:', error);
        }
    };
    HistoryService.prototype.generateId = function () {
        return Date.now().toString(36) + Math.random().toString(36).substr(2);
    };
    HistoryService.$inject = ['$window', '$http', '$q', '$rootScope'];
    return HistoryService;
}());
exports.HistoryService = HistoryService;
function HistoryServiceFactory($window, $http, $q, $rootScope) {
    return new HistoryService($window, $http, $q, $rootScope);
}
exports.HistoryServiceFactory = HistoryServiceFactory;
HistoryServiceFactory.$inject = ['$window', '$http', '$q', '$rootScope'];
exports.default = HistoryServiceFactory;
